'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.asyncValidate = exports.validate = undefined;

var _revalidate = require('revalidate');

var _emailValidator = require('email-validator');

var _emailValidator2 = _interopRequireDefault(_emailValidator);

var _auth = require('redux/modules/auth');

var _bluebird = require('bluebird');

var _bluebird2 = _interopRequireDefault(_bluebird);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validate = exports.validate = (0, _revalidate.combineValidators)({
  email: (0, _revalidate.createValidator)(function (message) {
    return function (value) {
      return value && _emailValidator2.default.validate(value.replace(/\s/g, '')) ? undefined : message;
    };
  }, 'The email address seems to be invalid.')(),
  password: (0, _revalidate.composeValidators)((0, _revalidate.isRequired)({
    message: 'Please enter a password'
  }), (0, _revalidate.hasLengthGreaterThan)(5)({
    message: 'Please enter a password of at least 6 characters.'
  }))()
});

var asyncValidate = exports.asyncValidate = function asyncValidate(values, dispatch) {
  if (!values.email || !values.email.length) {
    return _bluebird2.default.resolve();
  }

  return dispatch((0, _auth.checkIfExists)(values.email, 'register')).then(function (e) {
    if (e.code != 'AccountNotFound') {
      throw { _error: e };
    }
  });
};


//////////////////
// WEBPACK FOOTER
// ./src/utils/onboardFormValidation.js
// module id = 1229
// module chunks = 0